import React from 'react';
import './video.scss';
import { Scrollbars } from 'react-custom-scrollbars';
import { umoksType } from '../../types/types.js';

class Video extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      'playVideo': ''
    };
  };

  componentDidMount() {
	    setTimeout(() => {
	    	const { videoList } = this.props;
      // if (this.props.videoList!== null)

      videoList && this.setState({ 'playVideo': videoList.playVideo });
    }, 1000);
  };

  componentWillUpdate() {

  };

	getVideoList = () => {
	  const { videoList } = this.props;

	  return videoList && videoList.videoList.map((item, i, arr) => {
	    const setVideo = () => {
	      this.setState({ 'playVideo': item.video });
	    };

	    return (
  <div key={'list-wrap-' + i} onClick={setVideo} className='list-wrap'>
	        <img src={item.img}/>
  <div className='video-title-wrap'>
      <div>
	            <h5>{item.title}</h5>
	            <span>{item.content}</span>
	          </div>
	        </div>
	      </div>
	    );
	  });
	};

	render() {
	  return (
  <section className='video-wrap f-center'>
  <div className='f-container'>
	        <div className='f-row'>
      <div className='f-item f-item-8 f-center'>
	            <div className='video-frame-wrap'>
          <iframe src={this.state.playVideo} frameBorder='0' allow='autoplay; encrypted-media'  />
        </div>
	          </div>
	          <div className='f-item f-item-4 f-center'>
	            <Scrollbars className='performer-scroll'
	              onUpdate={this.handleUpdate}
    autoHide={true}
	              autoHideTimeout={1000}
	              autoHideDuration={200}
	              thumbMinSize={30}
    universal={true}
    style={{ height: '400px' }}
	              renderTrackHorizontal={props => <div {...props} className='track-horizontal'/>}
	              renderTrackVertical={props => <div {...props} className='track-vertical'/>}
    renderThumbHorizontal={props => <div {...props} className='thumb-horizontal'/>}
    renderThumbVertical={props => <div {...props} className='thumb-vertical'/>}
    renderView={props => <div {...props} className='view'/>}>
    <div className='video-list-wrap'>
  {this.getVideoList()}
	              </div>
  </Scrollbars>
  </div>
    </div>

	      </div>
	    </section>
	  );
	};
};


Video.propTypes = {
  videoList:umoksType.isRequired
};


export default Video;



// WEBPACK FOOTER //
// ./src/client/components/video/video.jsx